// extracted by mini-css-extract-plugin
export default {"CommentSection":"ActivityMessage_CommentSection__3OLbC","UserName":"ActivityMessage_UserName__tn02F","details":"ActivityMessage_details__nSsuv","dot":"ActivityMessage_dot__fGbun"};